import { Module, Mutation } from 'vuex-module-decorators'
import BaseStore from '@/store/BaseStore'
import { BibliographySearchHistory } from '@/api'

export interface ModalBibliographySearchHistoryStoreInterface {
  onClickCancel?: any
  onClickDelete?: any
  onClickExecution?: any
  onClickLoading?: any
}

@Module({
  name: 'ModalBibliographySearchHistoryStore',
  namespaced: true,
  stateFactory: true
})
export default class ModalBibliographySearchHistoryStore extends BaseStore {
  _isOpen: boolean = false

  _cancelCallback?: any

  _deleteCallback?: any

  _executionCallback?: any

  _loadingCallback?: any

  get isOpen(): boolean {
    return this._isOpen
  }

  @Mutation
  public open(params?: ModalBibliographySearchHistoryStoreInterface) {
    this._isOpen = true
    this._cancelCallback = params?.onClickCancel
    this._deleteCallback = params?.onClickDelete
    this._executionCallback = params?.onClickExecution
    this._loadingCallback = params?.onClickLoading
  }

  @Mutation
  public close() {
    this._isOpen = false
  }

  @Mutation
  public cancel() {
    if (this._cancelCallback !== undefined) {
      this._cancelCallback()
    }

    this._isOpen = false
  }

  @Mutation
  public delete() {
    if (this._deleteCallback !== undefined) {
      this._deleteCallback()
    }

    this._isOpen = false
  }

  @Mutation
  public execution(item: BibliographySearchHistory) {
    if (this._executionCallback !== undefined) {
      this._executionCallback(item)
    }

    this._isOpen = false
  }

  @Mutation
  public loading(item: BibliographySearchHistory) {
    if (this._loadingCallback !== undefined) {
      this._loadingCallback(item)
    }

    this._isOpen = false
  }
}
